import { render, staticRenderFns } from "./AreaChartProcess.vue?vue&type=template&id=db1443d4&lang=pug"
import script from "./AreaChartProcess.vue?vue&type=script&lang=js"
export * from "./AreaChartProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports